import React, { useEffect, useState } from "react";
import NextImage from "../common/NextImage";
import { getMatchImageUrl, teamLeagueInfoUrl } from "../../utils/generalLiveCenter";
import { loadStyles } from "../../utils/cssLoader";
const IceHockeyDetailInfo = ({ ServerData, sport, loadCSS,
  dataClient,
  difference,
  title, summary, websiteBaseUrl,
  dataPath }) => {
  const [clientData, setClientData] = useState(null);
  const data = dataClient ? clientData : ServerData;

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.headData?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("icehockeyMatch");
    }
  }, [loadCSS]);
  return (
    <div>
      {title ? <h1>{title}</h1> : null}
      <div className="basket_tv">
        <div className="global_table striped player_lineup">
          <table>
            <thead>
              <tr>
                <th>Rounds</th>
                <th>P1</th>
                <th>P2</th>
                <th>P3</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="players_inf">
                    <div className="avtar">
                      <NextImage
                        src={getMatchImageUrl(sport, data?.competitors?.htid)}
                        width={26}
                        height={26}
                        alt="team"
                      />
                    </div>
                    <div className="avtar_inf">
                      <a href={teamLeagueInfoUrl({
                        dataClient,
                        websiteBaseUrl,
                        dataPath,
                        category: "team",
                        sport,
                        name: data?.competitors?.htn,
                        id: data?.competitors?.htid,
                      })}>
                        <strong className="name">
                          {data?.competitors?.htn}
                        </strong>
                      </a>
                    </div>
                  </div>
                </td>
                <td>{data?.p1?.split("-")[0] || "-"}</td>
                <td>{data?.p2?.split("-")[0] || "-"}</td>
                <td>{data?.p3?.split("-")[0] || "-"}</td>
              </tr>
              <tr>
                <td>
                  <div className="players_inf">
                    <div className="avtar">
                      <NextImage
                        src={getMatchImageUrl("icehockey", data?.competitors?.atid)}
                        width={26}
                        height={26}
                        alt="team"
                      />
                    </div>
                    <div className="avtar_inf">
                      <a href={teamLeagueInfoUrl({
                        dataClient,
                        websiteBaseUrl,
                        dataPath,
                        category: "team",
                        sport,
                        name: data?.competitors?.atn,
                        id: data?.competitors?.atid,
                      })}>
                        <strong className="name">
                          {data?.competitors?.atn}
                        </strong>
                      </a>
                    </div>
                  </div>
                </td>
                <td>{data?.p1?.split("-")[1] || "-"}</td>
                <td>{data?.p2?.split("-")[1] || "-"}</td>
                <td>{data?.p3?.split("-")[1] || "-"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default IceHockeyDetailInfo;
